/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";

export const StyledPrimarySidebarItem = styled('a')({
  textDecoration: 'none',
  color: 'black',
  fontSize: '13px',
});

export const disabledItemStyle = {
  color: '#a6a6a6',
};
